<template>
    <div>

        <div class="dropdown-mobile">
            <span class="e-resulttext">{{resultCount}} {{resultsCountLabel}}</span>
            <div class="top-toggle">Refine results:</div>
            <div class="filters">

                <div class="e-close">
                    Close
                </div>

                <h4>Refine Results:</h4>

                <span class="results">{{resultCount}} {{resultsCountLabel}}</span>

                <template v-if="searchFilters.ShowKeywordFilter">
                    <div class="keyword">
                        <label for="searchFilterKeywordsMobile" class="sr-only">Search by keyword</label>
                        <input type="text"
                               id="searchFilterKeywordsMobile"
                               name="keywords"
                               placeholder="Search by keyword..."
                               v-model="keywords"
                               v-on:keyup="filtersChanged">
                        <button type="submit" class="keyword__search-btn">
                            <span class="search-icon">
                                <svg aria-hidden="true" viewBox="0 0 24 24">
                                    <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z"/>
                                </svg>
                            </span>
                            <span class="sr-only">Submit search</span>
                        </button>
                    </div>
                </template>

                <active-filters :search-filters="searchFilters" v-if="searchFilters"></active-filters>

                <template v-if="searchFilters && searchFilters.FilterList && searchFilters.FilterList.Filters">
                    <div class="dropdown" v-for="(filter, index) in searchFilters.FilterList.Filters" :key="index" :id="'dropdown-sml-' + index">
                        <div class="dropdown__header">
                            <h3 class="dropdown__title">
                                <button ref="'dropdownTrigger' + index" @click="toggleCollapsible($event, index)" class="dropdown__title-btn" aria-expanded="false" :aria-controls="'mobile-dropdown-panel-' + filter.Id">
                                    <span>{{filter.Name}}</span>
                                    <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                                </button>
                            </h3>
                        </div>
                        <div :id="'mobile-dropdown-panel-' + filter.Id" class="dropdown__body" :class="{ 'js-expanded': index === activeItem }">
                            <div class="dropdown__filters">
                                <ul>
                                    <li v-for="filterTag in filter.FilterTags" :key="filterTag.Tag.Id">
                                        <div class="dropdown__checkbox">
                                            <input class="filter-picker"
                                                :id="'mobile-tag-' + filterTag.Tag.Id"
                                                :name="formatFilterName(filter)"
                                                type="checkbox"
                                                v-model="filters[formatFilterName(filter)]"
                                                v-on:change="filtersChanged"
                                                :value="filterTag.Tag.Id" 
                                                :data-filtername="filterTag.Tag.Name" 
                                                :data-filtercategory="filter.Name" />
                                            <label :for="'mobile-tag-' + filterTag.Tag.Id">
                                                {{filterTag.Tag.Name}}
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        
        <active-filters :search-filters="searchFilters" v-if="searchFilters"></active-filters>
        
        <template v-if="searchFilters.ShowKeywordFilter">
            <div class="keyword">
                <label for="searchFilterKeywords" class="sr-only">Keyword search</label>
                <input class="keyword__input" type="text"
                       id="searchFilterKeywords"
                       name="keywords"
                       placeholder="Keyword search"
                       v-model="keywords"
                       v-on:keyup="filtersChanged">
                <button type="submit" class="keyword__search-btn">
                    <span class="search-icon">
                        <svg aria-hidden="true" viewBox="0 0 24 24">
                            <path d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z"/>
                        </svg>
                    </span>
                    <span class="sr-only">Submit search</span>
                </button>
            </div>
        </template>

        <div class="dropdown-container">
            <template v-if="searchFilters && searchFilters.FilterList && searchFilters.FilterList.Filters">
                <div class="dropdown" v-for="(filter, index) in searchFilters.FilterList.Filters" :key="index" :id="'dropdown-lrg-' + index">
                    <div class="dropdown__header">
                        <h3 class="dropdown__title">
                            <button ref="'dropdownTrigger' + index" @click="toggleCollapsible($event, index)" class="dropdown__title-btn" aria-expanded="false" :aria-controls="'dropdown-panel-' + filter.Id">
                                <span>{{filter.Name}}</span>
                                <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                            </button>
                        </h3>
                    </div>
                    <div :id="'dropdown-panel-' + filter.Id" class="dropdown__body" :class="{ 'js-expanded': index === activeItem }">
                        <div class="dropdown__filters">
                            <ul>
                                <li v-for="filterTag in filter.FilterTags" :key="filterTag.Tag.Id">
                                    <div class="dropdown__checkbox">
                                        <input class="filter-picker"
                                            :id="'tag-' + filterTag.Tag.Id"
                                            :name="formatFilterName(filter)"
                                            type="checkbox"
                                            v-model="filters[formatFilterName(filter)]"
                                            v-on:change="filtersChanged"
                                            :value="filterTag.Tag.Id"
                                            :data-filtername="filterTag.Tag.Name"
                                            :data-filtercategory="filter.Name" />
                                        <label :for="'tag-' + filterTag.Tag.Id">
                                            {{filterTag.Tag.Name}}
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import ActiveFilters from '@/components/SiteSearch/search-active-filters'
    export default {
        components: {
            ActiveFilters
        },

        computed: {
            console: () => console,
            document: () => document,

            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            }
        },

        created: function () {
            this.init()
        },

        data() {
            return {
                activeDropdownKey: null,
                activeMobile: false,
                date: this.$store.state.search.filters.date,
                filterTimeout: null,
                loading: false,
                keywords: this.$store.state.search.filters.keywords,
                selectedFilters: {},
                searchFilters: {},
                updatingFilters: false,
                activeItem: null
            }
        },

        methods: {

            toggleCollapsible(event, i) {

                if (event && event.preventDefault) {
                    event.preventDefault()
                    const toggleLink = event.currentTarget
                    const state = toggleLink.getAttribute('aria-expanded')
                    const allToggles = document.querySelectorAll('.dropdown__title-btn')

                    if (state === 'false') {
                        allToggles.forEach(el => el.setAttribute('aria-expanded', false))
                        toggleLink.setAttribute('aria-expanded', true)
                        this.activeItem = i
                    } else {
                        toggleLink.setAttribute('aria-expanded', false)
                        this.activeItem = null
                    }
                }
            },

            onBlur: function () { 
                this.isVisible = null
            },

            filtersChanged: function () {
                const vm = this

                if (vm.updatingFilters && vm.filterTimeout) {
                    clearTimeout(vm.filterTimeout)
                }

                vm.filterTimeout = setTimeout(function () {
                    vm.$store.dispatch('updateSearchFilter', {
                        key: 'date',
                        value: vm.date
                    })
                    vm.$store.dispatch('updateSearchFilter', {
                        key: 'keywords',
                        value: vm.keywords
                    })

                    Object.keys(vm.filters).forEach(key => {
                        vm.$store.dispatch('updateSearchFilter', {
                            key: key,
                            value: vm.filters[key]
                        })
                    })

                    vm.$eventHub.$emit('search-filtersChanged')

                    vm.updatingFilters = false
                }, 500)

                vm.updatingFilters = true
            },

            formatFilterName: function (filter) {
                return 'filter_' + filter.Id
            },

            init: function () {
                var vm = this
                vm.loading = true

                const getSearchFilters = function () {
                    return Axios.get('/umbraco/api/SearchApi/SearchFilters', {
                        params: { currentPageId: currentPageId }
                    })
                }

                Axios.all([getSearchFilters()])
                    .then(
                        Axios.spread(function (searchFilters) {
                            vm.searchFilters = searchFilters.data

                            if (
                                vm.searchFilters &&
                                vm.searchFilters.FilterList &&
                                vm.searchFilters.FilterList.Filters
                            ) {
                                vm.searchFilters.FilterList.Filters.forEach(function (filter) {
                                    const filterName = vm.formatFilterName(filter)

                                    if (!vm.filters[filterName]) {
                                        vm.$set(vm.filters, filterName, [])

                                        vm.$store.dispatch('addSearchFilter', {
                                            filterName: filterName,
                                            initialValue: []
                                        })
                                    }
                                })
                            }

                            vm.loading = false
                        })
                    )
                    .catch(() => {
                        vm.loading = false
                    })
            }
        },

        mounted: function () {
            this.toggleCollapsible()
        },

        mixins: [globalMixin],

        props: {
            resultsCountLabel: {
                default: 'results',
                type: String
            },

            showResultsCount: {
                default: true,
                type: Boolean
            }
        }
    }
</script>